import type { Product, ProductApiResponse } from '../../../@types/product';

export const productsToApp = (productsRes: ProductApiResponse): Product[] => {
  if (!productsRes) return [];
  return productsRes;
};
